import React, { useState } from "react";
import { Avatar, Dropdown, Layout, Menu } from "antd";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import {
  TeamOutlined,
  KeyOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  SafetyOutlined,
  DownOutlined,
} from "@ant-design/icons";
import "./index.css";

const { Header, Sider, Content } = Layout;

export default function IndexModule() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const items = [
    {
      key: "managers",
      icon: <TeamOutlined />,
      label: <Link to="/managers">商户管理</Link>,
    },
    {
      key: "account",
      icon: <SafetyOutlined />,
      label: "安全中心",
      children: [
        { key: "password", icon: <KeyOutlined />, label: <Link to="/password/change">修改密码</Link> },
        { key: "logout", icon: <LogoutOutlined />, label: "退出登录" },
      ],
    },
  ];

  const selectedKey = location.pathname.startsWith("/managers")
    ? "managers"
    : location.pathname.startsWith("/password/change")
    ? "password"
    : "managers";
  const openKeys = items.filter((item) => item.children).map((item) => item.key);

  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
      localStorage.removeItem("admin");
      localStorage.removeItem("token");
      navigate("/login", { replace: true });
    }
  };
  const userMenuItems = [{ key: "logout", label: "退出登录" }];

  return (
    <Layout className="manager-layout" style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div
          style={{
            height: 48,
            margin: 16,
            background: "rgba(255,255,255,.2)",
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontWeight: 600,
            letterSpacing: 0.2,
          }}
        >
          {collapsed ? "总后台" : "总后台"}
        </div>
        <Menu
          theme="dark"
          selectedKeys={[selectedKey]}
          defaultOpenKeys={openKeys}
          mode="inline"
          items={items}
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            background: "#fff",
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              type="button"
              onClick={() => setCollapsed((prev) => !prev)}
              style={{
                width: 32,
                height: 32,
                border: "none",
                background: "transparent",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 16,
              }}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </button>
          </div>
          <Dropdown
            menu={{
              items: userMenuItems,
              onClick: handleMenuClick,
            }}
            placement="bottomRight"
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
              <Avatar size={32} icon={<UserOutlined />} />
              <DownOutlined style={{ color: "#6b7280", fontSize: 12 }} />
            </div>
          </Dropdown>
        </Header>
        <Content style={{ margin: 16, display: "flex", overflow: "hidden" }}>
          <div
            style={{
              background: "#fff",
              flex: 1,
              minHeight: 0,
              minWidth: 0,
              padding: 16,
              overflow: "auto",
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
